/** Product microcopy — keep wording consistent across the app. */
export const MICROCOPY = {
  employeeIdPrivacy: "Employee IDs keep reports privacy-safe.",
  lockedPayPeriod: "Locked pay periods cannot be changed without an admin reason.",
  equipmentCostSeparate: "Equipment cost is tracked separately from worker gross pay.",
  highestMultiplier: "Highest multiplier wins unless stacking is enabled.",
  auditLogSaved: "Every important change is saved in the Werkio Audit Trail.",
  exportPermission: "Exports are permission-checked and stored privately in R2.",
  dailyEntryFieldMode: "Field mode — tap hours, job code, and equipment per worker.",
  geofencePrivacy:
    "Location is captured only when you submit this day — never tracked in the background.",
} as const;
